import { useRouter } from 'next/router';

import { useGetProductQuery } from '../model/product.query';

export const useGetProduct = () => {
  const { query } = useRouter();
  const { amount, period, productId } = query || {};

  const { data } = useGetProductQuery(
    { amount: amount ? Number(amount) : undefined, term: period, id: productId, productType: 'Credit' },
    { skip: !productId },
  );

  return data;
};
